import {cargoApiURL} from '@logistics-frontend/client-core/api/corp'
import {fetch} from '@logistics-frontend/core/utils/network'
import {Optional} from '@logistics-frontend/types'
import {addQuery, get} from '@logistics-frontend/utils'

import {BoundedCard, BoundedCardsListResponse, V1ClientCardListRequest} from '../types'

export function fetchBoundedCards(
  clientId: string,
  body: V1ClientCardListRequest,
  country?: string,
  makeUrl = cargoApiURL,
): Promise<Optional<BoundedCard[]>> {
  return fetch<V1ClientCardListRequest, BoundedCardsListResponse, BoundedCardsListResponse>({
    method: 'POST',
    url: addQuery(makeUrl('cargo-corp/v1/client/card/list'), {country}),
    headers: {
      'X-B2B-Client-ID': clientId,
    },
    body,
  }).then(get('bound_cards'))
}
